import { render, staticRenderFns } from "./fenxiang.vue?vue&type=template&id=ef65117e&scoped=true"
import script from "./fenxiang.vue?vue&type=script&lang=js"
export * from "./fenxiang.vue?vue&type=script&lang=js"
import style0 from "./fenxiang.vue?vue&type=style&index=0&id=ef65117e&prod&lang=css"
import style1 from "./fenxiang.vue?vue&type=style&index=1&id=ef65117e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef65117e",
  null
  
)

export default component.exports